import { gql } from "@apollo/client";

export const CREATE_UPDATE_SELLER_TRANSACTION = gql`
mutation createUpdatePayment($input: createUpdateInput) {
  createUpdatePayment(input: $input) {
    status
    message
  }
}
`
//for admin purpose
export const GET_PAYMENT_TRANSACTION = gql`
query GetPaymentTransactionDataForAdmin($page: Int, $limit: Int, $filter: String, $sort: userSort, $search: String, $from: String, $to: String,$customerId:ID) {
  getPaymentTransactionDataForAdmin(page: $page, limit: $limit, filter: $filter, sort: $sort, search: $search, from: $from, to: $to,customerId:$customerId) {
    count
    data {
      id
      orderIds {
        id
        customerId
        cfOrderId
        order_number
        delivery_order_Date
        cod_payment_status
        final_order_amount
        net_receivable_amount
        pickupAddress {
          name
          phone
          address1
          city
          stateId {
            id
            name
          }
          zipCode
          customerId
        }
        deliveryAddress {
          name
          phone
          address1
          city
          zipCode
          customerId
        }
        stateId
        dayDifference
        trackStatus
        total_charges
        order_amount
        codCollectableValue
        payment_type
        package_weight
        isDeleted
        isActive
        payment_order_Date
        status
        paymentDetails
        manifest
        order_id
        awb_number
        ProductPrice
        ProductName
        createdAt
        paymentStatus
        package_weight_Length
      }
      customerId
      cod_payment_status
      paymentAmount
      totalShipment
      isActive
      createdAt
    }
  }
}
`
// for customer purpose
export const GET_CUSTOMER_PAYMENT_TRANSACTION = gql`
query GetPaymentTransactionForCustomer( $to: String, $from: String, $search: String, $sort: userSort, $page: Int, $limit: Int, $filter: String) {
  getPaymentTransactionForCustomer( to: $to, from: $from, search: $search, sort: $sort, page: $page, limit: $limit, filter: $filter) {
      count
    data {
      id
      orderIds {
        id
        customerId
        order_number
        delivery_order_Date
        cod_payment_status
        final_order_amount
        net_receivable_amount
        pickupAddress {
          name
          phone
          address1
          city
          stateId {
            id
            name
          }
          zipCode
          customerId
        }
        deliveryAddress {
          name
          phone
          address1
          city
          zipCode
          customerId
        }
        stateId
        dayDifference
        trackStatus
        total_charges
        order_amount
        codCollectableValue
        payment_type
        package_weight
        isDeleted
        isActive
        payment_order_Date
        status
        paymentDetails
        manifest
        order_id
        awb_number
        ProductPrice
        ProductName
        createdAt
        paymentStatus
        package_weight_Length
      }
      cod_payment_status
      remittance_id
      remittance_amount
      paymentAmount
      totalShipment
      isActive
      createdAt
    }
  }
}
`

export const GET_COD_REMITTANCE_SUMMERY = gql`
query GetRemittanceSummary {
  getRemittanceSummary {
    remittedTillDate
    lastRemittance
    nextRemittance
    totalRemittanceDue
  }
}
`